import React from 'react';
import BoostedComponent from './BoostedComponent'

class ReservationInformations extends BoostedComponent {
  constructor(props) {
    super(props)
    this.state = {
      activite_nom: "",
      responsable_nom: "",
      responsable_courriel: "",
      responsable_telephone: ""
    }
    this.constants = this.props.constants
  }
  componentDidUpdate(prevProps,prevState) {
    if (this.state !== prevState) {
      this.props.parent.setState(this.state)
    }
  }
  render() {
    return(
      <div className="ReservationInformations">
          <h3>{this.constants.information}</h3>
        <div className="label">
          <label>{this.constants.activiteNom}</label>
          <input type="text" name="activite_nom" value={this.state.activite_nom} onChange={this.handleInputChange} />
        </div>
        <div className="label">
          <label>{this.constants.responsable}</label>
          <input type="text" name="responsable_nom" value={this.state.responsable_nom} onChange={this.handleInputChange} />

        </div>
        <div className="label">
          <label>{this.constants.courriel}</label>
          <input type="text" name="responsable_courriel" value={this.state.responsable_courriel} onChange={this.handleInputChange} />

        </div>
        <div className="label">
          <label>{this.constants.telephone}</label>
          <input type="tel" name="responsable_telephone" value={this.state.responsable_telephone} onChange={this.handleInputChange} />

        </div>
      </div>
    )
  }
}
export default ReservationInformations;



// WEBPACK FOOTER //
// ./src/ReservationInformations.js